import Model from "./base/model";

class Status extends Model{
  resourceName() {
    return "status";
  }

  fields() {
    return {
      name: "",
      description: "",
      created_at:"",
      updated_at:"",
      occurrence_datetime: "",
    };
  }
}

export default new Status();
